/*==========================================
=            Geo Location Store            =
==========================================*/

// imports
import settings from '../../config/index'

// Store, this is the single source of truth that powers the application
const state = {
  response: {},
  error: null,
  message: null,
  valid: null
}

// mutations calls are sync operations and are the only place that the store can be updated.
const mutations = {
  SET_RESPONSE (state, payload) {
    state.response = payload
    state.error = false
  },
  SET_ERROR (state, bool) {
    state.error = bool
  },  
  SET_VALID (state, bool) {
    state.valid = bool
  },  
  SET_MESSAGE (state, message) {
    state.message = message
  },   
}

// For async operations use actions, used mostly with ajax calls
const actions = {
    getCurrentGeoLocation ({ commit, state }, response = {}) {
      console.log("getCurrentGeoLocation finding position...")      
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log("getCurrentGeoLocation Success!", position)
          let result = {
            position: { lat: parseFloat(position.coords.latitude.toFixed(7)), lng: parseFloat(position.coords.longitude.toFixed(7)) },
            title: 'My location (' + position.coords.latitude.toFixed(7) + ',' + position.coords.longitude.toFixed(7) + ')',
            lat: parseFloat(position.coords.latitude.toFixed(7)),
            lng: parseFloat(position.coords.longitude.toFixed(7)),
            accuracy: position.coords.accuracy,
            speed: position.coords.speed,
            timestamp: moment().format('YYYY-MM-DD H:mm:ss'),
            enabled: true
          }
          // over ride
          // result.lat = parseFloat(37.354107777.toFixed(7));
          // result.lng = parseFloat(-121.955235678.toFixed(7));
          // result.position = { lat: parseFloat(result.lat), lng: parseFloat(result.lng) }
          // console.log("**", { ...result, valid: true })
          commit('SET_RESPONSE', result);
          commit('SET_VALID', true);    
          commit('SET_MESSAGE', 'Location Found!');
        },
        (error) => {
          console.log('getCurrentGeoLocation ERROR', error);
          commit('SET_RESPONSE', error)          
          commit('SET_ERROR', true)          
          commit('SET_VALID', false)
          switch(error.code) {
            case error.PERMISSION_DENIED:
                commit('SET_MESSAGE', 'User denied the request for Geolocation.');
                console.log("User denied the request for Geolocation.")
                break;
            case error.POSITION_UNAVAILABLE:
                commit('SET_MESSAGE', 'Location information is unavailable.');
                console.log("Location information is unavailable.")
                break;
            case error.TIMEOUT:
                commit('SET_MESSAGE', 'The request to get user location timed out.');
                console.log("The request to get user location timed out.")
                break;
            case error.UNKNOWN_ERROR:
                commit('SET_MESSAGE', 'An unknown error occurred.');
                console.log("An unknown error occurred.")
                break;
          }
        });
    }
}

// Getters are a way to grab computed data from the store
const getters = {
  response: state => state.response,
  valid: state => state.valid,
 }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/geo-location.js